<!--
 * @Author: hzm
 * @Date: 2022-11-30 09:26:30
 * @Description: 
-->

<template>
  <div>
    <header class="admin-header">
      <div class="admin-header__inner">
        <div class="admin-header__logo">
          <div class="logo__img">
            <a :href="env == 'staging' ? '/mro' : '/'"><el-image :src="Logo" fit="fill" :lazy="true"></el-image></a>
          </div>
          <div class="logo__text">{{ title }}</div>
          <div class="ml-4">
            <TopNav> </TopNav>
          </div>
        </div>
        <div class="admin-header__info mr-16px">
          <!-- <span class="info__welcome info--space" v-if="userStore.userId"> 欢迎您: {{ userStore.userName }} </span>
          <div class="info__line info--space" v-if="userStore.userId">|</div>
        
           采购商城 -->
          <!-- 工具 -->
          <div class="flex items-center text-16px">
            <i class="el-icon-shopping-bag-1 mr-1"></i>
            <el-link type="info" :underline="false" href="/" class="!text-[#606266]" target="_blank">采购商城</el-link>
          </div>
          <ZoomInOur class="mx-2"></ZoomInOur>

          <div class="mr-16px">
            <Message :userCenterUrl="userCenterUrl"></Message>
          </div>
          <div>
            <el-dropdown class="" trigger="click" v-if="userStore.userId">
              <div class="flex justify-center items-center">
                <el-avatar class="user-avatar" :src="userStore.avatar || defaultAvatar">
                  <img :src="defaultAvatar" />
                </el-avatar>
                <!-- <img :src="avatar||defaultAvatar"
                     class="user-avatar" /> -->
                <i class="el-icon-caret-bottom text-[#06C167]"></i>
              </div>
              <el-dropdown-menu slot="dropdown" class="user-dropdown">
                <router-link :to="userCenterUrl">
                  <el-dropdown-item>{{ userStore.userName }}</el-dropdown-item>
                </router-link>
                <el-dropdown-item divided @click.native="loginOrOut">
                  <span>退出登录</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
    </header>
  </div>
</template>

<script setup lang="ts">
import Logo from '@/assets/images/logo.svg';
import defaultAvatar from '@/assets/images/defaultavatar.svg';
import ZoomInOur from './zoomInOur.vue';
import { userInfo } from '@/stores/userInfo';
import Message from './message.vue';
import TopNav from './TopNav.vue';
const env = import.meta.env.VITE_APP_ENV;
const props = defineProps({
  title: {
    type: String,
    default: '',
  },
  userCenterUrl: {
    type: String,
    default: '',
  },
});
const userStore = userInfo();

function loginOrOut() {
  if (!userStore.userId) {
    useRouter().push('/');
  } else {
    userStore.LogOut().finally(res => {
      useRouter().push('/login');
    });
  }
}
</script>

<style scoped lang="scss">
.admin-header {
  height: 60px;
  color: #909090;

  .admin-header__inner {
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    height: 100%;

    .admin-header__logo {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;

      .logo__img {
        width: 40px;
      }

      .logo__text {
        margin-left: 16px;
        color: #333333;
        font-weight: bold;
      }
    }

    .admin-header__info {
      .info--space {
        margin-left: 12px;
      }

      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #606266;
      font-size: 14px;

      .info__line {
        color: #dadada;
      }
    }
  }
}
</style>
